export default __webpack_public_path__ + "static/media/RightArrow.6eb56cb3.svg";